import { useNavigate } from "react-router-dom";
import Login from "../components/Login/Login";
import Consent from "../components/Consent/Consent";
import PreviewPdf from "../components/Consent/PreviewPdf";
import Esign from "../components/Consent/Esign";
import PdfReview from "../components/Consent/PdfReview";
import ProductInfo from "../components/ProductInfo/ProductInfo";
import Dashboard from "../components/Dashboard/Dashboard";
import Contact from "../components/Contact/Contact";
import Notification from "../components/Notification/Notification";
import FAQs from "../components/FAQs/FAQs";
import Settings from "../components/Settings/Settings";
import ProfileChange from "../components/Settings/ProfileChange";
import SupportRequest from "../components/Settings/SupportRequest";
import ManageNotification from "../components/Settings/ManageNotification";
import Claims from "../components/Claims/Claims";
import HealthRiskAssessment from "../components/Claims/HealthRiskAssessment";
import DoctorVisit from "../components/Claims/DoctorVisit";
import DoctorVisitForm from "../components/Claims/DoctorVisitForm";
import HealthQuiz from "../components/Claims/HealthQuiz";
import QuizList from "../components/Claims/QuizList";
import Anxiety from "../components/Claims/Anxiety";
import Langauge from "../components/Login/LanguageSelection";
import Form from "../components/Claims/Form";
import Dpcextra from "../components/Dashboard/Dpcextra";
import Quiz from "../components/Claims/Quiz";
import PdfReview2 from "../components/Consent/PdfPreview2";
import ExplanationOfBenifitaHistoryDetails from "../components/ExplanationOfBeniftsHistory/ExplanationOfBenifitaHistoryDetails";
import FormInfo from "../components/Claims/FormInfo";
import { useEffect } from "react";
import OpenEnrollment from "../components/GuestUser/OpenEnrollment";
import LoginNumberListing from "../components/GuestUser/LoginNumberListing";
import VerifyPhoneNumber from "../components/GuestUser/VerifyPhoneNumber";
import EducationalContent from "../components/GuestUser/EducationalContent";
import EducationalContentPaycheck from "../components/GuestUser/EducationalContentPaycheck";
import EducationalContentEnrollment from "../components/GuestUser/EducationalContentEnrollment";
import EducationalContentESign from "../components/GuestUser/EducationalContentESign";
import EducationalContentThankYou from "../components/GuestUser/EducationalContentThankYou";
import EnrollmentDeclineConfirmation from "../components/GuestUser/EnrollmentDeclineConfirmation";
import GivingUpConfirmOption from "../components/GuestUser/GivingUpConfirmOption";
import TermsOfUseAndCondition from "../components/GuestUser/TermsOfUseAndCondition";
import Welcome from "../components/GuestUser/Welcome";
import { MEMBER_TOKEN_KEY } from "../common/authSession";
import UpdatedPaycheck from "../components/GuestUser/UpdatedContentPaycheck";
import AppStoreRedirect from "../components/GuestUser/AppStoreRedirect";

const NoMatch = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/dashboard');
  }, [navigate]);

  return null;
};

export const getRoutes = () => {
  const isAuthenticated = !!localStorage.getItem(MEMBER_TOKEN_KEY);

  return [
    {
      element: Dashboard,
      path: "/dashboard",
      isPrivate: true,
      isLayout: true,
    },
    {
      element: Dpcextra,
      path: "/dpcextra",
      isPrivate: true,
      isLayout: true,
    },
    {
      element: Login,
      path: "/login",
      isPrivate: false,
      isLayout: false,
    },

    {
      element: Consent,
      path: "/consent",
      isPrivate: false,
      isLayout: false,
    },
    {
      element: ExplanationOfBenifitaHistoryDetails,
      path: "/explanation-of-benifits-history",
      isPrivate: true,
      isLayout: false,
    },
    {
      element: PreviewPdf,
      path: "/preview-pdf",
      isPrivate: false,
      isLayout: false,
    },
    {
      element: Esign,
      path: "/eSign",
      isPrivate: false,
      isLayout: false,
    },

    {
      element: PdfReview,
      path: "/pdf-review",
      isPrivate: false,
      isLayout: false,
    },
    {
      element: PdfReview2,
      path: "/show-sign-document",
      isPrivate: false,
      isLayout: false,
    },
    {
      element: ProductInfo,
      path: "/product-info",
      isPrivate: true,
      isLayout: true,
    },
    {
      element: Contact,
      path: "/contact",
      isPrivate: true,
      isLayout: true,
    },
    {
      element: Notification,
      path: "/notification",
      isPrivate: true,
      isLayout: false,
    },
    {
      element: FAQs,
      path: "/FAQs",
      isPrivate: true,
      isLayout: true,
    },
    {
      element: Settings,
      path: "/settings",
      isPrivate: true,
      isLayout: true,
    },
    {
      element: Claims,
      path: "/claims",
      isPrivate: true,
      isLayout: true,
    },
    {
      element: ProfileChange,
      path: "/profile-change",
      isPrivate: true,
      isLayout: true,
    },
    {
      element: SupportRequest,
      path: "/support-request",
      isPrivate: isAuthenticated,
      isLayout: isAuthenticated,
    },
    {
      element: ManageNotification,
      path: "/manage-notification",
      isPrivate: true,
      isLayout: true,
    },
    {
      element: HealthRiskAssessment,
      path: "/health-risk-assessment",
      isPrivate: true,
      isLayout: false,
    },
    {
      element: DoctorVisit,
      path: "/doctor-visit",
      isPrivate: true,
      isLayout: false,
    },
    {
      element: DoctorVisitForm,
      path: "/doctor-visit-form",
      isPrivate: false,
      isLayout: false,
    },
    {
      element: HealthQuiz,
      path: "/health-quiz",
      isPrivate: true,
      isLayout: true,
    },
    {
      element: FormInfo,
      path: "/form-info",
      isPrivate: true,
      isLayout: true,
    },
    {
      element: QuizList,
      path: "/quiz-list",
      isPrivate: true,
      isLayout: true,
    },
    {
      element: Anxiety,
      path: "/anxiety",
      isPrivate: true,
      isLayout: false,
    },
    {
      element: Form,
      path: "/form",
      isPrivate: true,
      isLayout: true,
    },
    {
      element: Quiz,
      path: "/quiz-form",
      isPrivate: true,
      isLayout: true,
    },
    {
      element: Langauge,
      path: "/",
      isPrivate: false,
      isLayout: false,
    },
    {
      element: AppStoreRedirect,
      path: "/download-app",
      isPrivate: false,
      isLayout: false,
    },

    // Guest enrollment flow (separate from member private routes; see GuestUserRoute)
    {
      element: OpenEnrollment,
      path: "/guest-user/open-enrollment",
      isPrivate: false,
      isLayout: false,
      isGuestRoute: true,
      guestRouteRequiresAuth: false,
    },
    {
      element: LoginNumberListing,
      path: "/guest-user/number-listing",
      isPrivate: false,
      isLayout: false,
      isGuestRoute: true,
      guestRouteRequiresAuth: false,
    },
    {
      element: VerifyPhoneNumber,
      path: "/guest-user/verify-phone-number",
      isPrivate: false,
      isLayout: false,
      isGuestRoute: true,
      guestRouteRequiresAuth: false,
    },
    {
      element: TermsOfUseAndCondition,
      path: "/guest-user/terms-of-use-and-condition",
      isPrivate: false,
      isLayout: false,
      isGuestRoute: true,
      guestRouteRequiresAuth: true,
    },
    {
      element: Welcome,
      path: "/guest-user/welcome",
      isPrivate: false,
      isLayout: false,
      isGuestRoute: true,
      guestRouteRequiresAuth: true,
    },
    {
      element: EducationalContent,
      path: "/guest-user/educational-content",
      isPrivate: false,
      isLayout: false,
      isGuestRoute: true,
      guestRouteRequiresAuth: true,
    },
    {
      element: EducationalContentPaycheck,
      path: "/guest-user/paycheck",
      isPrivate: false,
      isLayout: false,
      isGuestRoute: true,
      guestRouteRequiresAuth: true,
    },
    {
      element: UpdatedPaycheck,
      path: "/guest-user/updated-paycheck",
      isPrivate: false,
      isLayout: false,
      isGuestRoute: true,
      guestRouteRequiresAuth: true,
    },
    {
      element: EducationalContentEnrollment,
      path: "/guest-user/enrollment",
      isPrivate: false,
      isLayout: false,
      isGuestRoute: true,
      guestRouteRequiresAuth: true,
    },
    {
      element: EnrollmentDeclineConfirmation,
      path: "/guest-user/enrollment-decline-confirmation",
      isPrivate: false,
      isLayout: false,
      isGuestRoute: true,
      guestRouteRequiresAuth: true,
    },
    {
      element: GivingUpConfirmOption,
      path: "/guest-user/giving-up-confirm-option",
      isPrivate: false,
      isLayout: false,
      isGuestRoute: true,
      guestRouteRequiresAuth: true,
    },
    {
      element: EducationalContentESign,
      path: "/guest-user/esign",
      isPrivate: false,
      isLayout: false,
      isGuestRoute: true,
      guestRouteRequiresAuth: true,
    },
    {
      element: EducationalContentThankYou,
      path: "/guest-user/thank-you",
      isPrivate: false,
      isLayout: false,
      isGuestRoute: true,
      guestRouteRequiresAuth: true,
    },

    { path: "*", element: NoMatch },
  ];
};
